import React from 'react';
import { SensorsView } from './components';
import { useSensorsController } from './hooks/useSensorsController';
import type { SensorsProps } from './types';
import './sensors.css';

/**
 * Sensors settings page component
 *
 * Manages company sensor connections including adding, editing, deleting,
 * and viewing sensor provider details.
 *
 * @param title - Page title to display
 */
const Sensors: React.FC<SensorsProps> = ({ title }) => {
  const controller = useSensorsController();

  return <SensorsView controller={controller} title={title} />;
};

export default Sensors;
